// Ever-Eden Style Pagination - Exact Copy
(function() {
  'use strict';
  
  function addEverEdenPagination() {
    // Only run on mobile
    if (window.innerWidth > 767) return;
    
    console.log('Adding Ever-Eden style pagination...');
    
    // Find all product galleries
    const galleries = document.querySelectorAll('.js-product-slider, .js-product-slider-single');
    
    galleries.forEach(gallery => {
      if (gallery.hasAttribute('data-ever-eden-pagination')) return;
      gallery.setAttribute('data-ever-eden-pagination', 'true');
      
      const wrapper = gallery.closest('.media-gallery');
      if (!wrapper) return;
      
      const slides = gallery.querySelectorAll('.media-gallery__item');
      const slideCount = slides.length;
      
      if (slideCount <= 1) return;
      
      console.log(`Found gallery with ${slideCount} slides`);
      
      // Create pagination exactly like Ever-Eden
      const paginationContainer = document.createElement('div');
      paginationContainer.className = 'swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal mobile-gallery-pagination';
      
      // Create bullets
      for (let i = 0; i < slideCount; i++) {
        const bullet = document.createElement('span');
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('tabindex', '0');
        bullet.setAttribute('role', 'button');
        bullet.setAttribute('aria-label', `Go to slide ${i + 1}`);
        
        if (i === 0) {
          bullet.classList.add('swiper-pagination-bullet-active');
        }
        
        // Add click handler
        bullet.addEventListener('click', () => {
          if (typeof $ !== 'undefined' && $(gallery).hasClass('slick-initialized')) {
            $(gallery).slick('slickGoTo', i);
          }
        });
        
        paginationContainer.appendChild(bullet);
      }
      
      // Add to wrapper
      wrapper.appendChild(paginationContainer);
      
      console.log('Created pagination with', slideCount, 'bullets');
      
      // Listen for slide changes if jQuery/Slick is available
      if (typeof $ !== 'undefined') {
        $(gallery).on('afterChange', function(event, slick, currentSlide) {
          console.log('Slide changed to:', currentSlide);
          updatePagination(paginationContainer, currentSlide);
        });
      }
    });
  }
  
  function updatePagination(paginationContainer, activeIndex) {
    const bullets = paginationContainer.querySelectorAll('.swiper-pagination-bullet');
    bullets.forEach((bullet, index) => {
      bullet.classList.toggle('swiper-pagination-bullet-active', index === activeIndex);
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addEverEdenPagination);
  } else {
    addEverEdenPagination();
  }
  
  // Also try after a delay to catch late-loading galleries
  setTimeout(addEverEdenPagination, 1000);
  setTimeout(addEverEdenPagination, 2000);
  
  // Handle variant changes
  document.addEventListener('variant:change', () => {
    setTimeout(addEverEdenPagination, 500);
  });
  
  // Handle Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(addEverEdenPagination, 500);
    });
  }
})();